import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
// 菜单，侧边栏
// import dashboard from './modules/dashboard';
import member from "./modules/member";
import coupon from "./modules/coupon";
import operation from "./modules/operation";
import marketing from "./modules/marketing";
import trade from "./modules/trade";
import report from "./modules/report";
import system from "./modules/system";

// 系统
// import log from './modules/log';

export default [].concat(_toConsumableArray(member), _toConsumableArray(coupon), _toConsumableArray(operation), _toConsumableArray(marketing), _toConsumableArray(trade), _toConsumableArray(report), _toConsumableArray(system));